import { Component, HostListener, OnDestroy, OnInit, signal } from '@angular/core';
import { Menu, NavMenuItem } from './_classes';
import {
    FollowedPlayerService, LocalStorageService, TimelineService, RouteParserService,
    AppStringsService, AccountService, AnalyticsService, SessionService,
    ScheduleEntriesService
} from './_services';
import { PrivacyPolicyDialogComponent, CookiePopupComponent } from './_modules/cookie-popup/cookie-popup.component'
import { AdsService } from './_services/ads.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { WhatsNewDialogComponent } from './_dialogs/whats-new-dialog/whats-new-dialog.component';
import { environment } from 'src/environments/environment';
import { UAParser } from 'ua-parser-js';
import { ContestRulesDialogComponent } from './_dialogs/contest-rules-dialog/contest-rules-dialog.component';
import { hasCookie } from 'src/app/_functions';
import { MatDialog } from '@angular/material/dialog';
import { TickerInformationComponent } from './_modules/ticker-information/ticker-information.component';
import { TopNavComponent } from './_modules/top-nav/top-nav.component';
import { SsrlocalstoreService } from './_services/ssr-localstore.service';
import { LoadingIndicatorComponent } from './_modules/loading-indicator/loading-indicator.component';
import { MatListItem, MatListItemIcon, MatListItemTitle, MatNavList } from '@angular/material/list';
import { AccountModel } from './_interfaces';

import { SsrAdService } from './_services/ssr-ad.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterLink, MatNavList, RouterLinkActive, MatListItem, MatListItemIcon, MatListItemTitle, RouterOutlet, TopNavComponent, TickerInformationComponent, LoadingIndicatorComponent]
})
export class AppComponent implements OnInit, OnDestroy {
    public isMobileWidth = false;
    public isHomeRoute = false;
    private routerSub?: Subscription;
    public activeSession: BehaviorSubject<number> = new BehaviorSubject<number>(0)
    public isTabHidden: boolean = false
    public is_mobile: boolean = false;
    public show_nav: boolean = false;
    public mainMenu: NavMenuItem[] = [];
    public footerLinks = [
        {
            label: `about.terms.button.label`,
            route: 'terms'
        },
        {
            label: `about.privacy.button.label`,
            route: `policy`
        },
        {
            label: `Cookies`,
            route: 'cookies'
        }
    ];

    // TODO: Use GolfONE
    public socialLinks = [
        {
            dark_icon_url: 'https://res.cloudinary.com/bleachr/image/upload/v1658939204/TennisONE/Logos/facebook_white.svg',
            light_icon_url: 'https://res.cloudinary.com/bleachr/image/upload/v1658939204/TennisONE/Logos/facebook_black.svg',
            link: 'https://www.facebook.com/people/Golf-one-App/61577164011902'
        },
        {
            dark_icon_url: 'https://res.cloudinary.com/bleachr/image/upload/v1658939204/TennisONE/Logos/Instagram_white.svg',
            light_icon_url: 'https://res.cloudinary.com/bleachr/image/upload/v1658939204/TennisONE/Logos/instagram_black.svg',
            link: 'https://www.instagram.com/golfoneapp'
        },
        {
            dark_icon_url: 'assets/golf/x_white.png',
            light_icon_url: 'assets/golf/x_black.png',
            link: 'https://x.com/GolfONEApp'
        },
        {
            dark_icon_url: 'https://res.cloudinary.com/bleachr/image/upload/v1658939204/TennisONE/Logos/tiktok_white.svg',
            light_icon_url: 'https://res.cloudinary.com/bleachr/image/upload/v1658939204/TennisONE/Logos/tiktok_black.svg',
            link: 'https://www.youtube.com/channel/UCGTMaChTH_WGNlsQX678XaA'
        },
    ]
    public currentRoute: string = '';
    public account: AccountModel | null = null;
    private accountSub?: Subscription;
    public loading = signal(true)

    constructor(
        public dialog: MatDialog,
        public appStringAPI: AppStringsService,
        private localStore: LocalStorageService,
        private timelineAPI: TimelineService,
        private followAPI: FollowedPlayerService,
        private routerAPI: RouteParserService,
        private accountAPI: AccountService,
        private scheduledEntryAPI: ScheduleEntriesService,
        private analytics: AnalyticsService,
        private adAPI: AdsService,
        private sessionService: SessionService,
        private router: Router,
        private ssr: SsrlocalstoreService,
        private ssrAdService: SsrAdService
    ) {
        // if (window.innerWidth < 550) {
        //     this.is_mobile = true;
        // } else {
        //     this.is_mobile = false;
        //     this.show_nav = true;
        // }

        // Build total session only once 
        this.sessionService.buildSessions()

        // Set tournament session if a user views a tournament schedule entry
        router?.events?.subscribe?.(() => {
            if (this.router.url !== this.currentRoute && this.router.url.includes('tournament/')) {
                this.currentRoute = this.router.url
                let sessions = JSON.parse(this.ssr.getItem('sessions') as string) || {};
                sessions.tournament = {
                    team: {
                        id: sessions?.tournament?.team?.id ? sessions.tournament.team.id : ''
                    },
                    type: 'tournament',
                    session_end_local: '',
                    session_start_local: new Date().toISOString()
                }
                this.ssr.setItem('sessions', JSON.stringify(sessions))
            }
        });

        this.accountSub = this.accountAPI.account.subscribe((account) => {
            this.account = account?.id ? account : null;
        });

        // this.overlayService.overlayState.subscribe(v => {
        //     const centerSection: HTMLElement = document.querySelector('#center-section')!

        //     if (v) {
        //         centerSection?.style?.setProperty?.('visibility', 'hidden')
        //         this.setOverlayWidth()
        //     } else {
        //         centerSection?.style?.setProperty?.('visibility', 'visible')
        //     }
        // })
    }

    ngOnDestroy(): void {
        this.accountSub?.unsubscribe();
        this.routerSub?.unsubscribe();
    }

    private cleanUrl(url?: string | null): string {
        const v = (url ?? '').trim();
        return v.length ? v : '';
    }

    get iosAppUrl(): string {
        return this.cleanUrl(this.account?.ios_app_version_url);
    }

    get androidAppUrl(): string {
        return this.cleanUrl(this.account?.android_app_version_url);
    }

    get showIosBadge(): boolean {
        return !!this.iosAppUrl;
    }

    get showAndroidBadge(): boolean {
        return !!this.androidAppUrl;
    }

    get showAnyStoreBadge(): boolean {
        return this.showIosBadge || this.showAndroidBadge;
    }

    get showStoreBadges(): boolean {
      if (this.isMobileWidth) {
          return this.showAnyStoreBadge && this.isHomeRoute;
      }

      return this.showAnyStoreBadge;
  }

    checkVideo(): boolean | void {
        if (this.accountAPI.account.value?.theme_config?.whats_new_content_url) {
            const extension = this.accountAPI.account.value?.theme_config?.whats_new_content_url?.split?.('.')?.pop?.()?.toLowerCase() || '';

            if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(extension)) {
                return false;
            } else if (['mp4', 'mov', 'mkv'].includes(extension)) {
                return true;
            }
        }
    }


    get currentYear(): string {
        return new Date().getFullYear().toString();
    }

    async openLink(route) {
        if (route === `terms`) {
            this.routerAPI.parseBleachrRoutes(`bleachr://internal/${route}`);
        } else if (route === `policy`) {
            this.openPolicyDialog();
        } else if (route === 'terms.bleachr.contests.url') {
            this.openContestRules();
        } else {
            this.openCookieDialog();
        }
    }

    openPolicyDialog() {
        const dialog = this.dialog.open(PrivacyPolicyDialogComponent, {
            width: '80%',
            height: '85%',
            panelClass: 'privacy-dialog',
        })
    }

    openContestRules() {
        const dialog = this.dialog.open(ContestRulesDialogComponent, {
            width: '80%',
            height: '85%',
            panelClass: 'privacy-dialog',
        })
    }

    openCookieDialog() {
        const dialog = this.dialog.open(CookiePopupComponent, {});
    }

    @HostListener('document:visibilitychange')
    visibilitychange() {
        this.isTabHidden = document?.hidden
        const sessions = JSON.parse(this.ssr.getItem('sessions') as string) || {};

        // Start new session if tab is hidden and current session is equal or greater than 1h
        if (
            this.isTabHidden
            && sessions?.total?.session_start_local
            && this.sessionService.isTotalSessionExpired(sessions.total.session_start_local)
        ) {
            sessions.total.session_start_local = new Date().toISOString()

            // If there is a team_id in a tournament session it means the user viewed a tournament
            // but did not clicked the exit button, in that case the tour session should be
            // closed out on next site launch (next session) with the end time matching the last event from that previous usage.
            // If there were no events (page views, button tap, filter taps) from the previous session to take the end time from,
            // just throw the event without an end away (remove session_end_local).
            if (sessions?.tournament?.team?.id) {
                if (!sessions?.total?.session_end_local) delete sessions.tournament.session_end_local
                this.analytics.postEvent('session', sessions.tournament)

                // Reset tournament session after posting event
                this.ssr.setItem('sessions', JSON.stringify({
                    ...sessions,
                    tournament: {
                        ...sessions.tournament,
                        team: {
                            id: ''
                        },
                        session_start_local: '',
                        session_end_local: ''
                    }
                }))
            }
        }
    }

    async ngOnInit() {
        try {
            if (new UAParser().getDevice()?.type) {
                this.openDownloadPrompt()
            }

            if (this.ssr.isClientSide) {
                await this.localStore.initLocalStore()
                await this.timelineAPI.getTimelineHub()
                await this.appStringAPI.handleInit()
                await this.followAPI.initFollowed()
                const sponsors = await this.adAPI.initAdService();
                this.ssrAdService.setSponsorPool(sponsors);
                await this.scheduledEntryAPI.initSearchEntryState()
                // this.accountAPI.showMatchCardChat()
                await this.accountAPI.getAccountPromise(environment.GOLF_ONE_ACCOUNT_ID)
                this.analytics.initFingerPrint()
                this.openWhatsNewDialog();
                this.accountAPI.tabs.subscribe(tabs => {
                    if (tabs?.length) {
                        const available_tabs = tabs.filter(({ visible }) => visible).map(({ title }) => title)
                        this.mainMenu = new Menu().getMainMenu().filter(({ label }) => {
                            return available_tabs.some(l => l!.includes(label))
                        })
                        available_tabs.forEach((loc) => {
                            this.mainMenu.forEach((item) => {
                                if (loc?.includes(item.label)) {
                                    item.label = loc;
                                }
                            })
                        })
                        this.loading.set(false)
                    }
                })
                // Every second check the total session status
                setInterval(() => {
                    this.activeSession.next(this.activeSession.getValue() + 1000)
                }, 1000)

                this.activeSession.subscribe(() => {
                    const sessions = JSON.parse(this.ssr.getItem('sessions') as string) || {};

                    // Only post totalSession to analytics if session has not expired and session data exists
                    if (
                        sessions?.total?.session_start_local
                        && sessions?.total?.session_end_local
                        && this.sessionService.isTotalSessionExpired(sessions.total.session_start_local)
                        && !this.isTabHidden
                    ) {
                        // Make sure end session is always greater than start session
                        // session_end_local will always be the timestamp of the last previous analytic event from the previous site usage session
                        if (new Date(sessions.total.session_end_local).getTime() > new Date(sessions.total.session_start_local).getTime()) {
                            this.analytics.postEvent('session', sessions.total);
                        }

                        // Sart new session
                        sessions.total.session_start_local = new Date().toISOString()
                        this.ssr.setItem('sessions', JSON.stringify(sessions))

                        // If there is a team_id in a tournament session it means the user viewed a tournament
                        // but did not clicked the exit button, in that case the tour session should be
                        // closed out on next site launch (next session) with the end time matching the last event from that previous usage.
                        // If there were no events (page views, button tap, filter taps) from the previous session to take the end time from,
                        // just throw the event without an end away (remove session_end_local).
                        if (sessions?.tournament?.team?.id) {
                            if (!sessions?.total?.session_end_local) delete sessions.tournament.session_end_local
                            this.analytics.postEvent('session', sessions.tournament)

                            // Reset tournament session after posting event
                            this.ssr.setItem('sessions', JSON.stringify({
                                ...sessions,
                                tournament: {
                                    ...sessions.tournament,
                                    team: {
                                        id: ''
                                    },
                                    session_start_local: '',
                                    session_end_local: ''
                                }
                            }))
                        }
                    }
                })

                this.updateUiFlags(this.router.url);

                this.routerSub = this.router.events.subscribe(() => {
                  this.updateUiFlags(this.router.url);
                });
            }
        } catch (err) {
            throw err
        }
    }

    openWhatsNewDialog() {
        if (this.ssr.isClientSide) {
            if (!hasCookie(`t1_privacy_policy`)) {
                return;
            }
        }

        // Once the user has seen this.account.theme_config?.whats_new_content_url we want to show the popup
        // again only if the URL has changed, we store the URL in local storage to track it.
        const savedURL = this.ssr.getItem('whatsNewContentURL');

        if (this.accountAPI.account.value?.theme_config?.whats_new_content_url && this.accountAPI.account.value?.theme_config?.whats_new_content_url !== savedURL) {
            this.ssr.setItem('whatsNewContentURL', this.accountAPI.account.value?.theme_config?.whats_new_content_url ?? '');

            this.dialog.open(WhatsNewDialogComponent, {
                data: this.accountAPI.account.value,
                panelClass: `whats_new_dialog`,
            });
        }
    }

    openDownloadPrompt(): void {
        try {
            return
        } catch (err) {
            throw err
        }
    }

    private computeIsMobileWidth(): boolean {
      if (!this.ssr.isClientSide) return false;
      return window.innerWidth <= 500;
    }

    private computeIsHomeRoute(url: string): boolean {
      const path = (url ?? '').split('?')[0].split('#')[0];

      return path === '/' || path === '/home';
    }

    private updateUiFlags(url?: string): void {
      this.isMobileWidth = this.computeIsMobileWidth();
      this.isHomeRoute = this.computeIsHomeRoute(url ?? this.router.url);
    }

    @HostListener('window:resize')
    onResize(): void {
      this.updateUiFlags();
    }
}
